import { Box, Button } from "@material-ui/core";
import React, { useMemo } from "react";
import EnhancedDropdownComponent from "../../../../Common/Dropdowns/EnhancedDropdownComponent";
import { Link } from "react-router-dom";

function SignableDocumentsTablePageActions({
    resources,
    selectedOutlet,
    setSelectedOutlet,
    accessibleMoboOutlets,
    isLoading
}) {

 const formattedOutlets = useMemo(() => {
    return accessibleMoboOutlets
      .sort((a, b) => a.description.localeCompare(b.description))
      .map((outlet) => ({
        key: outlet.id,
        name: outlet.description,
      }));
  }, [accessibleMoboOutlets]);

  return (
    <Box>
      <Box display="flex">
        <EnhancedDropdownComponent
          id="outlet-dropdown-grid"
          value={selectedOutlet}
          handleChange={(e) => setSelectedOutlet(parseInt(e.target.value))}
          options={formattedOutlets}
          labelText={resources["Outlet"]}
          style={{ width: "330px" }}
          placeholder={resources["All"]}
          disabled={isLoading}
        />
        <Link
          to={{
            pathname: "/signabledocuments/new",
            state: { outletId: selectedOutlet }
          }}
          
          style={{ textDecoration: "none", marginLeft: "auto", whiteSpace: 'nowrap' }}
        >
          <Button id="add-signable-documents" variant="contained" color="primary">
            <i
              className="fas fa-plus mr-2"
              title={resources["CreateSignableDocument"]}
            />
            {resources["CreateSignableDocument"]}
          </Button>
        </Link>
      </Box>
    </Box>
  );
}

export default SignableDocumentsTablePageActions;
